import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  constructor(private http: HttpClient) {}

  getCategoryColors(categoryCode: string) {
    // TODO: créer une route dans le back
  }

  getIcone() {
    // TODO: une route devrait déjà exister dans le back
  }

  getPageBanner() {
    // TODO: créer une route dans le back
  }
}
